module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticStyle: {
      "height": "65px"
    }
  }, [_c('navigator', {
    attrs: {
      "fullCalendar": _vm.fullCalendar
    },
    on: {
      "updateArrowDate": _vm.updateArrowDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-content-p d-flex flexGrow1 position-relative"
  }, [_vm._m(0), _vm._v(" "), _c('events')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexGrow1"
  }, [_c('div', {
    staticClass: "calendar-wrapper"
  }, [_c('div', {
    attrs: {
      "id": "calendar"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-26956e74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26956e74"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Calendar.vue
// module id = 1691
// module chunks = 0